import React from 'react';

import { Panel, PanelBreak, Panels, spacing, usePublicaTranslation } from '~/src/dash/publicaUI';
import { AllRulesContainer } from '~/src/dash/views/inventory-rules/AllRules/container';
import { TopBar } from '~/src/dash/views/topbar/TopBar';

export const InventoryRulesView = () => {
  const { t } = usePublicaTranslation();

  return (
    <Panels max vertical relative minWidthMain>
      <Panel largeHorizontalPadding verticalPadding>
        <TopBar title={t('InventoryRules')} />
      </Panel>
      <Panel>
        <AllRulesContainer />
      </Panel>
      <PanelBreak height={spacing.large} />
    </Panels>
  );
};
